import colors from '@sportninja/common/constants/appColors'

export type RegistrationStatusIcon = 'hourglass' | 'warning' | 'check' | 'close'

export interface RegistrationStatus {
  id: number
  /** The Status filter's label. */
  filterLabel: string
  /** The label in the cell, shorter where the filter's would not fit. */
  label: string
  icon: RegistrationStatusIcon
  color: string
}

export const REGISTRATION_STATUSES: RegistrationStatus[] = [
  {
    id: 1,
    filterLabel: 'Submitted',
    label: 'Submitted',
    icon: 'hourglass',
    color: colors.INFO_200,
  },
  {
    id: 2,
    filterLabel: 'Pending',
    label: 'Pending',
    icon: 'warning',
    color: colors.WARNING_200,
  },
  {
    id: 3,
    filterLabel: 'Approved',
    label: 'Approved',
    icon: 'check',
    color: colors.SUCCESS_200,
  },
  {
    id: 4,
    filterLabel: 'Approved w/ Conditions',
    label: 'Appd. w/ Cond.',
    icon: 'check',
    color: colors.WARNING_200,
  },
  {
    id: 5,
    filterLabel: 'Cancelled',
    label: 'Cancelled',
    icon: 'close',
    color: colors.ERROR_200,
  },
  {
    id: 6,
    filterLabel: 'In Progress',
    label: 'In Progress',
    icon: 'hourglass',
    color: colors.INFO_200,
  },
]
